export class fs {

    //fake
}